import React from "react";
import Loader from "./Loader";

const Button = ({
    btnText,
    type,
    onClick,
    btnClassname,
    btnCustomContent,
    isLoading,
    disabled,
    icon,
    iconRight,
    btnTextClassName,
}) => {
    return (
        <button
            onClick={(e) => onClick?.(e)}
            type={type ? type : "button"}
            disabled={disabled}
            className={`${btnClassname} w-full flex justify-center py-3 items-center px-4 bg-p-50 rounded-[4px] text-sm font-rocGroteskMedium text-white`}
        >
            {isLoading ? (
                <Loader color={"inherit"} size={4} />
            ) : btnCustomContent ? (
                btnCustomContent
            ) : (
                <>
                    {icon ? (
                        <div className="flex space-x-2">
                            {icon && !iconRight && <div> {icon}</div>}
                            <p className={btnTextClassName}> {btnText}</p>
                            {icon && iconRight && <div> {icon}</div>}
                        </div>
                    ) : (
                        btnText
                    )}
                </>
            )}
        </button>
    );
};

export default Button;
